module.exports = __webpack_public_path__ + "b675a6d4558f33c8651d0a339f3435a1.jpg";